export enum RaterApprovalOption {
  NotRequired           = 0,
  SelectedByParticipant = 1,
  SelectedByAdmin       = 2,
}
